import { Injectable } from '@angular/core';
import { commit } from '@core/operators';
import { map } from 'rxjs/operators';
import { Configs, DataService } from './data.service';
import { SynchronizationService } from './synchronization.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigsService {

  private configs: Configs = null;
  private editable: Configs = null;
  private _synchronized: boolean = false;

  public get synchronized(): boolean {
    return this._synchronized;
  }

  private _sync(notify = true) {

    if (notify) this.sync.notify(ConfigsService, false);

    this.ds.configs('get').subscribe(data => {
      if (data) {
        this.configs = data;        
        this.editable = { ...this.configs };
        this._synchronized = true;
        this.sync.notify(ConfigsService, true);
      }
      else {

        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    })
  }

  public synchronize() {
    this._sync();
  }

  public get cnyToVndConversion(): number {
    return this.configs ? this.configs.CnyToVndConversion : 0;
  }

  public set cnyToVndConversion(value: number) {
    if (this.configs) {
      this.editable.CnyToVndConversion = Math.max(1, value);
      this._synchronized = false;
    }
  }

  public get vndRoundingFactor(): number {
    return this.configs ? this.configs.VndRoundingFactor : 0;
  }

  public set vndRoundingFactor(value: number) {
    if (this.configs) {
      this.editable.VndRoundingFactor = Math.max(0, value);
      this._synchronized = false;
    }
  }


  public get invoiceResolvableDays(): number {
    return this.configs ? this.configs.InvoiceResolvableDays : 0;
  }

  public set invoiceResolvableDays(value: number) {
    if (this.configs) {
      this.editable.InvoiceResolvableDays = Math.max(0, value);
      this._synchronized = false;
    }
  }

  public get goodResolvableDays(): number {
    return this.configs ? this.configs.GoodResolvableDays : 0;
  }

  public set goodResolvableDays(value: number) {
    if (this.configs) {
      this.editable.GoodResolvableDays = Math.max(0, value);
      this._synchronized = false;
    }
  }

  public get maxPrototypeLength(): number {
    return this.configs ? this.configs.MaxPrototypeLength : 0;
  }

  public set maxPrototypeLength(value: number) {
    if (this.configs) {
      this.editable.MaxPrototypeLength = Math.max(0, value);
      this._synchronized = false;
    }
  }

  public get defaultProfitMargin(): number {
    return this.configs ? this.configs.DefaultProfitMargin : 0;
  }

  public set defaultProfitMargin(value: number) {
    if (this.configs) {
      this.editable.DefaultProfitMargin = Math.max(0, value);
      this._synchronized = false;
    }
  }

  public get defaultLogisticsMargin(): number {
    return this.configs ? this.configs.DefaultLogisticsMargin : 0;
  }

  public set defaultLogisticsMargin(value: number) {
    if (this.configs) {
      this.editable.DefaultLogisticsMargin = Math.max(0, value);
      this._synchronized = false;
    }
  }

  public update() {
    if (this.configs && !this._synchronized) {
      this.sync.with(ConfigsService).commit(done =>
        this.ds.configs('update', this.editable).subscribe(data => {
          if (data) {
            this.configs = data;
            this.editable = { ...data };
            this._synchronized = true;            
          }
          done();
        })
      )
    }
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    this.synchronize();
  }
}
